<template>
  <div class="app-wrapper home">
    <!-- header -->
    <navBarNoLab position="left" :onIndex="6"></navBarNoLab>
    <!-- end -->
    <!-- content-->
    <div class="main-container">
      <el-tabs v-model="activeName" class="dashboardTabs">
        <el-tab-pane
          label
          :name="String(item.id)"
          v-for="item in menuData.slice(0, 8)"
          :key="item.id"
        >
          <!-- <router-link
            @click.native="update(item)"
            slot="label"
            :to="
              item && item.routerName === null
                ? '/detail'
                : `${item.routerName}`
            "
          >
            <span>
              {{ item.name }}
              <em class="dataNum">({{ item.projects.length }})</em>
            </span>
          </router-link> -->
          <!-- Result -->
          <div class="list" v-if="itemData.length > 0">
            <div class="item-parent">
              <div
                style="padding-left: 10px; padding-right: 10px"
                v-for="value in itemData"
                :key="value.id"
                class="item-child"
              >
                <div @click="goDetails(value)">
                  <div class="divImg">
                    <img
                      src="../../assets/cover.jpg"
                      v-if="value.logoImage === null || value.logoImage === ''"
                    />
                    <img
                      v-lazy="{
                        src: value.logoImage.url,
                        loading: require('./../../assets/coverpic.jpg'),
                      }"
                      v-else
                    />
                  </div>
                  <p class="textInfo">
                    <span v-if="value.trade !== null">
                      <span
                        class="fontBg"
                        v-bind:style="{
                          background: '#ebeff5',
                          color: '#333',
                        }"
                        v-if="
                          value.trade.color === null || value.trade.color == ''
                        "
                        >{{ value.trade.name }}</span
                      >
                      <span
                        class="fontBg"
                        v-bind:style="{
                          background: hexToRgba(value.trade.color, 0.1),
                          color: value.trade.color,
                        }"
                        v-else
                        >{{ value.trade.name }}</span
                      >
                    </span>
                    {{ value.name }}
                    <!--<span class='rightMenu fontCol'><em class='fabulous'></em>1220</span>-->
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="noInfo">暂无数据</div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import navBarNoLab from "./../components/navBarNoLab";
import baseApi from "@/base/baseApi";
import { Categories } from "../../gqlapi/Categories.js";
import { Contents } from "../../gqlapi/Contents.js";

export default {
  name: "layout",
  components: {
    navBarNoLab,
  },
  data() {
    return {
      baseData: [],
      activeName: "4",
      colorData: [],
      menuData: [],
      itemData: [],
      srcs: "",
    };
  },
  methods: {
    update(item) {
      sessionStorage.setItem("subjectID", String(item.id));
    },
    // 获取列表
    goDetails(value) {
      sessionStorage.setItem("detailsId", value.id);
      let routerData;
      if (value.router) {
        routerData = this.$router.resolve({
          path: value.router,
        });
      } else if (value.p_template && value.p_template.code) {
        routerData = this.$router.resolve({
          path: "/" + value.p_template.code,
        });
      } else {
        routerData = this.$router.resolve({
          path: "/details",
        });
      }
      window.open(routerData.href, "_blank");
    },
    getList(ids) {
      // this.$apollo
      //   .query({
      //     query: Contents,
      //     variables: {
      //       subjectID: ids,
      //       isPublish: true,
      //     },
      //     // fetchPolicy: 'no-cache',
      //   })
        this.$axios.post('/api',{
            operationName: "Contents",
            variables:{
                subjectID: ids,
                isPublish: true,
            },
            query: Contents
        })
        .then((res) => {
          this.itemData = res.data.data.pContents;
          this.itemData.forEach((item) => {
            switch (item.id) {
              case "11":
                item.src = "black";
                break;
              case "9":
                item.src = "suyun";
                break;
              case "6":
                item.src = "zhiwei";
                break;
              case "13":
                item.src = "zhiniugu";
                break;
              case "17":
                item.src = "saas";
                break;
              case "19":
                item.src = "ihrm";
                break;
              case "15":
                item.src = "likede";
                break;
              case "20":
                item.src = "money";
                break;
              case "5":
                item.src = "health";
                break;
              case "8":
                item.src = "ice";
                break;
              case "22":
                item.src = "zhihui";
                break;
              case "21":
                item.src = "juhe";
                break;
              case "1":
                item.src = "buy";
                break;
              case "3":
                item.src = "chong";
                break;
              case "2":
                item.src = "qing";
                break;
              default:
                item.src = "";
            }
          });
        })
        .catch(() => {});
    },
    // 获取导航数据
    getData() {
        this.$axios.post('/api',{
            operationName: "Categories",
            variables:{
                isPublish: true,
            },
            query: Categories
        })
        .then((res) => {
          this.menuData = res.data.data.pCategories;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 处理背景半透明
    hexToRgba(hex, opacity) {
      return (
        "rgba(" +
        parseInt("0x" + hex.slice(1, 3)) +
        "," +
        parseInt("0x" + hex.slice(3, 5)) +
        "," +
        parseInt("0x" + hex.slice(5, 7)) +
        "," +
        opacity +
        ")"
      );
    },
  },
  created() {
    this.colorData = baseApi.colorData;
    this.getData();
    this.getList(this.activeName);
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  .list {
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    padding-top: 0px;
    .item-parent {
      margin-left: -10px;
      margin-right: -10px;
      padding-left: 10px;
      .item-child {
        width: 261px;
        height: 153px;
        padding: 10px;
        float: left;
        margin-left: 10px;
        margin-bottom: 10px;
        overflow: hidden;
        border: 0 solid #dcdee3;
        border-radius: 5px;
        box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);
        background: #fff;
        transition: all 0.5s;
        cursor: pointer;
        .divImg {
          img {
            width: 261px;
            height: 123px;
          }
        }
        p {
          margin-top: -7px;
        }
        &:hover {
          transform: scale(1.03);
        }
      }
    }
  }
}
.bottom {
  p {
    text-align: center;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
<style lang="scss">
.app-wrapper {
  .main-container {
    .el-tabs {
      margin-top: 0px;
      .el-tabs__item.is-top:nth-child(2) {
        padding-left: 0 !important;
      }
      .el-tabs__item.is-top:last-child {
        padding-right: 0 !important;
      }
      .el-tabs__header {
        margin-top: 0;
        min-width: 1266px;
      }
    }
    .dashboardTabs {
      .el-tabs__item {
        padding: 0 !important;
        a {
          display: block;
          height: 30px;
          padding: 0 20px;
        }
      }
    }
  }
}
</style>
